import React, { useContext, useEffect, useState } from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import "../Style/StoneDetail.css";
import { AppLanguage } from "../context/ApplicationLanguage";
import axios from "axios";
import { useTranslation } from "react-i18next";

const API_BASE_URL = "https://server-alwaleedstone.onrender.com";

const StoneDetail = () => {
  const location = useLocation();
  const { stone } = location.state || {};
  const [dataTostone, setDataTostone] = useState(null);
  const [subImages, setSubImages] = useState([]);
  const appLang = useContext(AppLanguage);
  const { id } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/stone/${id}?lang=${appLang.language}`)
      .then((res) => {
        setDataTostone(res.data);
        setSubImages(res.data.subImages || []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id, appLang.language]);

  const getLocalizedText = (obj) => {
    if (!obj) return "";
    return typeof obj[appLang.language] === "string" ? obj[appLang.language] : "";
  };

  if (!dataTostone) {
    return <div>{t("loading")}</div>;
  }

  return (
    <div
      className="stone-detail"
      dir={appLang.language === "he" ? "rtl" : "ltr"}
    >
      <h2>{getLocalizedText(dataTostone.stoneName)}</h2>

      {/* صورة الحجر الرئيسية */}
      <img
        src={dataTostone.mainImage}
        alt={getLocalizedText(dataTostone.stoneName)}
        className="stone-main-image"
      />

      {/* العنوان الفرعي */}
      <div className="stone-gallery">
        <div className="stone-gallery-title">
          <h2>{t("stone.finishes")}</h2>
        </div>

        {subImages.length === 0 && <p>{t("stone.noImages")}</p>}

        {subImages.map((item) => (
          <Link
            key={item._id}
            to="/orderform"
            state={{
              stone: {
                label: getLocalizedText(dataTostone.stoneName),
                src2: dataTostone.mainImage,
              },
              selectedImage: {
                name: item.name,
                src: item.image,
              },
            }}
            className="stone-gallery-link"
          >
            <div className="stone-gallery-item">
              <div className="stone-gallery-image-wrapper">
                <img
                  src={item.image}
                  alt={getLocalizedText(item.name)}
                  className="stone-gallery-image"
                />
              </div>

              {/* اسم النوع */}
              <p className="stone-image-name">
                {getLocalizedText(item.name)}
              </p>

              {/* السعر */}
              <p className="project-price">
                {item.stonePrice ? `$${item.stonePrice}` : t("stone.priceUnavailable")}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default StoneDetail;
